import { render, staticRenderFns } from "./ContactsAnalytics.vue?vue&type=template&id=2dfbac5e&scoped=true&"
import script from "./ContactsAnalytics.vue?vue&type=script&lang=js&"
export * from "./ContactsAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfbac5e",
  null
  
)

export default component.exports